import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ErrorMsgHandler } from "../shared/errormanagement/handleerror";
import { SharedService } from "../services/shared.service";

@Injectable()

export class SettingsVarService {
    constructor(
        public sharedService: SharedService
    ) {
        this.sharedService.userLoggedoff_.subscribe((val) => {
//console.log("trigger user logout")
            this.resetUserlandingPages();
            this.resetRolelandingPages();
            this.userList.length = 0;
            this.role_list.length = 0;
            this.userPagination.setValue(this.sharedService.metaData.studio.studioDefault.Pagination);
            this.rolePagination.setValue(this.sharedService.metaData.studio.studioDefault.Pagination);
            this.errorhandleuserlanding.resetError();
            this.errorhandlerolelanding.resetError();
        })
    }

    commonData: any = this.sharedService.metaData.commonData;//common data
    nodata = this.sharedService.metaData.alert.noDatamsg[1]

    // user landing variables
    errorhandleuserlanding = new ErrorMsgHandler();
    userTableHeader: any = this.sharedService.metaData.settings.usertableHeader;

    userList: any = [];

    pages = {   //pagination
        presentPage: 1,
        length: 1
    };

    userPagination = new FormControl(this.sharedService.metaData.studio.studioDefault.Pagination);

    //role landing variables
    errorhandlerolelanding = new ErrorMsgHandler();
    roleTableHeader: any = this.sharedService.metaData.settings.roletableHeader;

    role_list: any = [];

    role_pages = {   //role pagination
        presentPage: 1,
        length: 1
    };

    rolePagination = new FormControl(this.sharedService.metaData.studio.studioDefault.Pagination);

    moduleName={
        "user":"user",
        "role":"role",
        "organization":"organization"
    }


    //Organization landing variables
    // organizationTableHeader: any = this.userloginservice.metaData.settings.roletableHeader;
    organizationTableHeader: any = [
        // { "disp": "S.NO", "value": "sno" },
        { "disp": "SERVICE PROVIDER", "value": "serviceProvider" },
        { "disp": "CUSTOMER", "value": "customerFullName" },
        { "disp": "SHORT NAME", "value": "customerShortName" },
        { "disp": "DOMIAN NAME", "value": "domain_name" },
        { "disp": "LICENCE TYPE", "value": "licenceType" },
        { "disp": "LICENCE VALIDITY", "value": "licenceValidity" },
        { "disp": "CREATED ON", "value": "createdDt" },
        { "disp": "", "value": "edit_data" },

    ]

    organization_list: any = [];

    organization_pages = {   //organization pagination
        presentPage: 1,
        length: 1
    };
    organizationPagination = new FormControl(this.sharedService.metaData.studio.studioDefault.Pagination);


    resetUserlandingPages() {
        this.pages.presentPage = 1;
        this.pages.length = 1;
    }

    resetRolelandingPages() {
        this.role_pages.presentPage = 1;
        this.role_pages.length = 1;
    }

}